import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';

import EditableToggle from './EditableToggle';
import { parsePastedNumericValue } from '../../utils/numberInputHelpers';

const EditableNumber = ({
  onChange,
  value = null,
  submitOnBlur = true,
  inputClassName = '',
  displayClassName = '',
  readOnly = false,
  placeholder = '',
  allowDecimals = true,
  displayValue = undefined,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    displayValue={
      displayValue ?? (!value && value !== 0 ? null : <FormattedNumber value={value} />)
    }
    className={displayClassName}
  >
    {({ inputValue, handleChange, inputRef, submit, cancel, handleKeyDown }) => (
      <input
        type="number"
        value={inputValue === null ? '' : inputValue}
        onChange={handleChange}
        ref={inputRef}
        onPaste={e => {
          e.preventDefault();
          const pastedValue = e.clipboardData.getData('text/plain');
          const numericValue = parsePastedNumericValue(pastedValue);
          if (numericValue !== null) {
            e.target.value = numericValue;
            handleChange(e);
          }
        }}
        onKeyPress={event => {
          if (!allowDecimals && (event.charCode === 44 || event.charCode === 46)) {
            event.preventDefault();
          }
        }}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={handleKeyDown}
        className={classnames('form-control', inputClassName)}
        placeholder={placeholder}
        autoComplete="off"
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  submitOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  displayClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  allowDecimals: PropTypes.bool,
  displayValue: PropTypes.node,
};

export default EditableNumber;
